// 静的デプロイ用モックデータサービス
export const mockDataService = {
  // 会議室データ
  getMeetingRooms: () => {
    return Promise.resolve({
      success: true,
      rooms: [
        {
          id: 1,
          name: '会議室A',
          capacity: 8,
          equipment: 'プロジェクター,ホワイトボード,WiFi',
          location: '1F',
          status: 'available'
        },
        {
          id: 2,
          name: '会議室B',
          capacity: 12,
          equipment: 'プロジェクター,TV,WiFi,テレビ会議',
          location: '1F',
          status: 'available'
        },
        {
          id: 3,
          name: '会議室C',
          capacity: 6,
          equipment: 'ホワイトボード,WiFi',
          location: '2F',
          status: 'occupied'
        },
        {
          id: 4,
          name: '大会議室',
          capacity: 24,
          equipment: 'プロジェクター,音響設備,テレビ会議,WiFi',
          location: '2F',
          status: 'available'
        },
        {
          id: 5,
          name: '応接室',
          capacity: 4,
          equipment: 'WiFi',
          location: '1F',
          status: 'available'
        }
      ]
    })
  },

  // 予約データ
  getReservations: () => {
    const today = new Date()
    const tomorrow = new Date(today)
    tomorrow.setDate(tomorrow.getDate() + 1)
    
    return Promise.resolve({
      success: true,
      reservations: [
        {
          id: 1,
          room_id: 1,
          room_name: '会議室A',
          title: '週次定例会議',
          organizer: '田中太郎',
          start_time: new Date(today.getTime() + 2 * 60 * 60 * 1000).toISOString(),
          end_time: new Date(today.getTime() + 3 * 60 * 60 * 1000).toISOString(),
          attendees: 6,
          status: 'confirmed'
        },
        {
          id: 2,
          room_id: 2,
          room_name: '会議室B',
          title: 'プロジェクト打ち合わせ',
          organizer: '佐藤花子',
          start_time: new Date(today.getTime() + 4 * 60 * 60 * 1000).toISOString(),
          end_time: new Date(today.getTime() + 5.5 * 60 * 60 * 1000).toISOString(),
          attendees: 8,
          status: 'confirmed'
        },
        {
          id: 3,
          room_id: 4,
          room_name: '大会議室',
          title: '月次全体会議',
          organizer: '鈴木一郎',
          start_time: new Date(tomorrow.getTime() + 10 * 60 * 60 * 1000).toISOString(),
          end_time: new Date(tomorrow.getTime() + 12 * 60 * 60 * 1000).toISOString(),
          attendees: 20,
          status: 'confirmed'
        }
      ]
    })
  },

  // 統計データ
  getStatistics: () => {
    return Promise.resolve({
      success: true,
      stats: {
        total_rooms: 5,
        available_rooms: 4,
        occupied_rooms: 1,
        utilization_rate: 0.65,
        today_reservations: 2,
        week_reservations: 12,
        popular_rooms: ['会議室A', '大会議室', '会議室B']
      }
    })
  },

  // 週間予約データ
  getWeeklyReservations: () => {
    const weekData = []
    const today = new Date()
    
    for (let i = 0; i < 7; i++) {
      const date = new Date(today)
      date.setDate(today.getDate() + i)
      
      weekData.push({
        date: date.toISOString().split('T')[0],
        count: Math.floor(Math.random() * 8) + 1,
        rooms: ['会議室A', '会議室B', '大会議室'].slice(0, Math.floor(Math.random() * 3) + 1)
      })
    }
    
    return Promise.resolve({
      success: true,
      weekly_data: weekData
    })
  },

  // 空室検索
  searchAvailableRooms: (date, startTime, endTime, capacity) => {
    return Promise.resolve({
      success: true,
      available_rooms: [
        {
          id: 1,
          name: '会議室A',
          capacity: 8,
          equipment: ['プロジェクター', 'ホワイトボード', 'WiFi'],
          location: '1F'
        },
        {
          id: 5,
          name: '応接室',
          capacity: 4,
          equipment: ['WiFi'],
          location: '1F'
        }
      ]
    })
  }
}

// 環境判定（静的デプロイかどうか）
export const isStaticDeployment = () => {
  return !window.location.hostname.includes('localhost') && 
         !window.location.hostname.includes('127.0.0.1')
}

// API呼び出しラッパー
export const apiCall = async (endpoint, options = {}) => {
  if (isStaticDeployment()) {
    // 静的デプロイ環境ではモックデータを使用
    switch (endpoint) {
      case '/api/meetings/rooms':
        return mockDataService.getMeetingRooms()
      case '/api/meetings/reservations':
        return mockDataService.getReservations()
      case '/api/meetings/statistics':
        return mockDataService.getStatistics()
      case '/api/meetings/weekly':
        return mockDataService.getWeeklyReservations()
      default:
        if (endpoint.includes('/api/meetings/search')) {
          return mockDataService.searchAvailableRooms()
        }
        return Promise.resolve({ success: false, error: 'Endpoint not found' })
    }
  } else {
    // 開発環境では実際のAPIを呼び出し
    const response = await fetch(endpoint, options)
    return response.json()
  }
}